import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectForm from '../../components/application/events/SelectForm';
import { fetch, change, select } from '../../actions/events/select';
import { eventsOptionsSelector, selectedEventIdSelector, eventsFetchedSelector } from '../../selectors/events/events';
import { getLastEvent } from '../../services/local.storage';

class SelectEvent extends Component {
    componentDidMount() {
        if (getLastEvent()) {
            this.props.change(getLastEvent());
            this._selectEvent();
        } else {
            this.props.fetch();
        }
    }
    _selectEvent = () => {
        this.props.select();
    };

    render() {
        return (
            <SelectForm
                selected={this.props.selectedEvent}
                onEventSelect={this.props.change}
                selectableEvents={this.props.events}
                onSubmit={this._selectEvent}
                eventsFetched={this.props.eventsFetched}
            />
        );
    }
}

const mapStateToProps = state => ({
    events: eventsOptionsSelector(state),
    eventsFetched: eventsFetchedSelector(state),
    selectedEvent: selectedEventIdSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetch, change, select }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SelectEvent);
